import styled, { css } from 'styled-components';

export const CardContainer = styled.div`
  width: 100%;
  height: 400px;
  /* overflow: hidden;   */
  color: white;

  @media only screen and (max-width: 600px) {
   width: 75%; 
  }
`;

export const BottomInfo = styled.div`
  position: relative;
  min-height: 160px;

  @media only screen and (max-width: 600px) {
    margin-top: 16px;
  }

`;

export const MoreInfo = styled.div`
  position: absolute;
  height: 80px;
  width: 100%;
  bottom: 0px;
  

  display: flex;
  justify-content: center; 
`;

export const PriceInfo = styled.div`
  margin-right: 10px;
  font-size: 13px;

  p {
    margin-bottom: 5px;
  }
`;